<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import configs from '../../config';
    import Carousel from 'svelte-carousel';
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faWallet,
        faMoneyBillTransfer,
        faClockRotateLeft,
        faHandHoldingDollar,
        faFutbolBall,
        faGamepad,
        faChevronCircleLeft,
        faUser,
        faGear,
        faDollar,
        faCircleNotch,
        faArrowsRotate,
        faBahtSign,
        faSignOut,
        faBath,
        faBathtub,
        faUserCircle,
        faArrowRotateRight,
        faGift,
        faGifts,
        faVolumeHigh,
        faRankingStar
        } from '@fortawesome/free-solid-svg-icons';
    import Device from 'svelte-device-info'
    import Swal from 'sweetalert2'

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let balance = 0.00
    let acc_name =""
    let member_name =""
    let gameHits = []
    let platformList = []

    let gametypeList = []
    let gameListHit = []
    let gameListHitDark = []
    let x = false

    let isPlarform = true
    let isGame = false 
    let isGameOtherDark = false 
    let isGameOther = false
    let loaDing = false;
    let loaDing2 = false;
    

    let platformPrefix = ""

    let device = 'desktop' 
    let background = '';
    let icon_cartoon = '';
    let icon_deposit = '';
    let icon_withdraw = '';
    let icon_history = '';
    let icon_aff = '';
    let createdtm = '';

    if(dataSetting.background=='' || dataSetting.background==undefined){
        background = 'https://i.gmz.asia/images/2023/08/25/ca7da20a9247be1aa8cb8907c2da5a8a.jpg';
    }else{
        background = dataSetting.background;
    }
    if(dataSetting.icon_cartoon=='' || dataSetting.icon_cartoon==undefined){
        icon_cartoon = 'https://i.gmz.asia/images/2024/01/16/3108a2e94c96fd1ad2f8a16aa9521acc.png';
    }else{
        icon_cartoon = dataSetting.icon_cartoon;
    }
    if(dataSetting.icon_deposit=='' || dataSetting.icon_deposit==undefined){
        icon_deposit = 'https://i.gmz.asia/images/2024/01/16/785db23daf11c82473418c3bed8344b4.png';
    }else{
        icon_deposit = dataSetting.icon_deposit;
    }
    if(dataSetting.icon_withdraw=='' || dataSetting.icon_withdraw==undefined){
        icon_withdraw = 'https://i.gmz.asia/images/2024/01/16/55b417e238bfce6f815ccb0c2299e770.png';
    }else{
        icon_withdraw = dataSetting.icon_withdraw;
    }
    if(dataSetting.icon_history=='' || dataSetting.icon_history==undefined){
        icon_history = 'https://i.gmz.asia/images/2024/01/16/d6ede3e04a42cfa666069327f14af373.png';
    }else{
        icon_history = dataSetting.icon_history;
    }
    if(dataSetting.icon_aff=='' || dataSetting.icon_aff==undefined){
        icon_aff = 'https://i.gmz.asia/images/2024/01/16/06a52a6ee324836dc2d988c57761edff.png';
    }else{
        icon_aff = dataSetting.icon_aff;
    }

    let objs
    let dataObs
    let  dsf = 'ds'
    if(dataSetting.other){
        dataObs =JSON.parse(dataSetting.other)
        //console.log('AAAAAAAAAAAAAAAA')
        if(dataObs.banner){
          //  console.log('AAAAAAAAAAAAAAAA')
            objs = dataObs.banner
        }
        //console.log('BBBBBBBBBBBBBBBBB')
    }
    //console.log(dataObs)
    let datass = '';
    async function checkNews(){
        let news ='';
        if(dataSetting.is_news=="O"){
            news = window.localStorage.getItem('news')
            if(news=='1'){

            }else{
                Swal.fire({
                    imageUrl: dataSetting.news_img,
                    html: dataSetting.news_desc+'<br /><input type="checkbox" value="1" id="closenews"/> ไม่ต้องแสดงอีก',
                    showCloseButton: true,
                    showCancelButton:true,
                    focusConfirm: false,
                    confirmButtonText: `
                        ดูรายละเอียด
                    `,
                    confirmButtonAriaLabel: "ดูรายละเอียด",
                    cancelButtonText: `
                        ปิด
                    `,
                    cancelButtonAriaLabel: "ปิด"
                }).then((result) => {
                    const inputRange = Swal.getInput()!
                    const inputNumber = Swal.getPopup()!.querySelector('#closenews') as HTMLInputElement
                    if (result.isConfirmed) {
                        if(dataSetting.news_img_link!=""){
                            window.open(dataSetting.news_img_link, '_blank').focus()
                        }
                        if(inputNumber.checked==true){window.localStorage.setItem("news",'1')}
                    } else if (result.isDenied) {
                        if(inputNumber.checked==true){window.localStorage.setItem("news",'1')}
                    }else{
                        if(inputNumber.checked==true){window.localStorage.setItem("news",'1')}
                    }
                });
            }
        }
    }

    async function openGame(prefix){
        if(prefix=='UFA'){
            // isPlarform = false
            getGameURL('UFA')
            return
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getplatform", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({prefix:prefix})
        })
        const json = await res.json()
        //console.log(json)
        if (json.statusCode==200) {
            gametypeList = json.payload
            platformPrefix = prefix
            isPlarform = false
            isGame = true
        } else {

            throw new Error(json);
        }
        
    }
    async function getGameURL(mgds) {

        Swal.fire({
            title: 'กรุณารอสักครู่',
            html: 'เรากำลังพาคุณเข้าสู่เกม ขอให้โชคดี Good Luck.',
            timer: 5000,
            timerProgressBar: true,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            },
            willClose: () => {
                
            }
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
                
            }
        })
        
        if(Device.isPhone){
            device = 'mobile'
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/startgame", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                _id:mgds,
                device:device,
                type:""
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            transferCash(json.txid,json.payload)
		} else {
            if(json.statusCode==205){
                Swal.fire({
                    title: "ไม่สามารถเล่นเกมได้",
                    text: json.message,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "ยกเลิกโปรโมชั่น",
                    cancelButtonText: "ปิด"
                    }).then((result) => {
                    if (result.isConfirmed) {
                        clearpromotion()
                    }
                });
            }else{
                Swal.fire(json.message)
            }
            isPlarform = true
            throw new Error(json);
		}
        
    }
    async function clearpromotion() {
        loaDing =false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/clearpromotion", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            Swal.fire(json.message)
		} else {
            Swal.fire(json.message)
            throw new Error(json);
		}
    }
    function closeGame(){
        gametypeList = []
        platformPrefix = ''
        isPlarform = true
        isGame = false
        isGameOther = false
    }
    function closeGameOther(){
        isPlarform = false
        isGame = true
        isGameOther = false
    }
    
    async function getBalance() {
        loaDing =false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getbalance", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            //console.log(json.payload)
            balance = json.payload.balance.toLocaleString('th-TH')
            acc_name = json.payload.username
            member_name = json.payload.name
            createdtm= json.payload.create
            loaDing = true
            loaDing2 = true
		} else {
            loaDing = true
            loaDing2 = true
            window.localStorage.clear();
            push('/')
            throw new Error(json);
		}
    }
    async function getBalance2() {
        loaDing2 = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getbalance", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            
            balance = json.payload.balance.toLocaleString('th-TH')
            acc_name = json.payload.username
            member_name = json.payload.name
            loaDing2 = true
		} else {
            loaDing2 = true
            window.localStorage.clear();
            push('/')
            throw new Error(json);
		}
    }
    async function transferCash(txid,url) {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/transfercash", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                txid:txid
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            // window.location = url
            window.open(url) 
            popUpGame(url)
		} else {

            throw new Error(json);
		}
    }
    async function popUpGame(url) {
        Swal.fire({
            title: '<strong><a href="'+url+'" target="_blank">เข้าสู่เกม</a></strong>',
            icon: 'info',
            html:
                'หากระบบไม่เปิดหน้าเกมอัตโนมัติกรุณาคลิกที่ปุ่ม <a href="'+url+'" target="_blank">เข้าสู่เกม</a>',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton:false,
            focusConfirm: false
        })
    }
    async function getPlatform() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getplatformlist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            platformList = json.payload
            if(platformList.length==1){
                
                if(platformList[0].platform_prefix!='UFA'){
                    isPlarform = false;
                    isGame = true
                    openGame(platformList[0].platform_prefix)
                }
                
            }
            let dataSetting = window.localStorage.getItem("setting")
            let vSetting = JSON.parse(dataSetting)
            if(vSetting.platform!=""){
                let newPlatform = []
                let xPlatform = JSON.parse(vSetting.platform)
                for await (const iterator of platformList) {
                    if(xPlatform.indexOf(iterator._id)!=-1){
                        newPlatform.push(iterator)
                    }
                }
                platformList = newPlatform
                if(platformList.length==1 && platformList[0].platform_prefix!='UFA'){
                    isPlarform = false;
                    isGame = true
                    openGame(platformList[0].platform_prefix)
                }
            }
            //platformList.unshift('lastgame')
            //platformList.unshift('gamehit')
            //console.log(platformList)
            x = true
		} else {

            throw new Error(json);
		}
    }
    async function Logout() {
        // loading = true
                window.localStorage.clear();
                setTimeout(() => {
                    window.location.href = dataSetting.member_url+'/#/auth'
                }, 1000);
                // push('/')
    }
    async function openGameOther(types){
        isGame =false
        if(types=='gamehit'){
            let datas = {
                platform: JSON.parse(dataSetting.platform)
            }
            const res = await fetch(window.localStorage.getItem("apiurl")+"member/getgamehit", {
                method: 'POST',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                    'x-api-appid': window.localStorage.getItem("appid")
                },
                body: qs.stringify(datas)
            })
            const json = await res.json()
            //console.log(json)
            if (json.statusCode==200) {
            gameListHit = json.payload
            isPlarform = false
            // isGame = isGameOther
            isGameOther = true
            } else {

                throw new Error(json);
            }
        }else if(types=='lastgame'){
            let datas = {
                platform: JSON.parse(dataSetting.platform)
            }
            const res = await fetch(window.localStorage.getItem("apiurl")+"member/getlastgamelist", {
                method: 'POST',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                    'x-api-appid': window.localStorage.getItem("appid")
                },
                body: qs.stringify(datas)
            })
            const json = await res.json()
            //console.log(json)
            if (json.statusCode==200) {
            gameListHit = json.payload
            isPlarform = false
            // isGame = isGameOther
            isGameOther = true
            } else {

                throw new Error(json);
            }
        }
    }
    async function openGameOtherDark(){
        //isGame =false
        let datas = {
            platform: JSON.parse(dataSetting.platform)
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getlastgamelist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify(datas)
        })
        const json = await res.json()
        //console.log(json)
        if (json.statusCode==200) {
        gameListHitDark = json.payload
        
        isGameOtherDark = true
        } else {

            throw new Error(json);
        }
    }
    async function checkPromotion() {
        let couponx = ""
        Swal.fire({
            title: "กรุณาระบุ Code",
            input: "text",
            inputAttributes: {
                autocapitalize: "off",
                align: "center"
            },
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true,
            preConfirm: async (login) => {
                try {
                    couponx = login
                    const res = await fetch(window.localStorage.getItem("apiurl")+"member/getpromotioncode", {
                        method: 'POST',
                        headers:{
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                            'x-api-appid': window.localStorage.getItem("appid")
                        },
                        body: qs.stringify({
                            _id:login
                        })
                    })
                    const json = await res.json()
                    return json
                } catch (error) {
                    Swal.showValidationMessage(`
                        Request failed: ${error}
                    `);
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            
            console.log(result)
            if (result.isConfirmed) {
                // Swal.fire({
                // title: `${result.value.login}'s avatar`,
                // imageUrl: result.value.avatar_url
                // });
                if(result.value.statusCode == 200){
                    window.localStorage.setItem("coupon",couponx)
                    push('/promotion/'+result.value.payload._id)
                    
                }else{
                    window.localStorage.setItem("coupon","")
                    Swal.fire(result.value.message)
                }
            }else{
                
            }
        });
    }
    let affbalance =0
    async function getAffiliate() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"affiliate/getaffiliate", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            affbalance = json.payload.member.wallet
		} 
        else if(json.statusCode==201){
            affbalance = 0
        }else {
            affbalance = 0
            throw new Error(json);
		}
    }
    getBalance()
    checkNews()
    let promise
    $: {

        promise = getPlatform()
        if(dataSetting.themes=='darkred' || dataSetting.themes=='darkblue' || dataSetting.themes=='darkgold' || dataSetting.themes=='darkgreen' || dataSetting.themes=='darkorange' || dataSetting.themes=='darkpink' || dataSetting.themes=='darkpurple'){  
            openGameOtherDark()
            getAffiliate()
        }
    }
    let dataRandomImg = [
		"./assets/images/avatar/avartar1.webp",
		"./assets/images/avatar/avartar2.webp",
		"./assets/images/avatar/avartar3.webp",
		"./assets/images/avatar/avartar4.webp",
	]
	let srcImg = dataRandomImg[Math.floor((Math.random()*dataRandomImg.length))];
</script>
<div class="default-home">
<div class="row pt-2 mb-5" style="background-image: url('{background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    <div class="col-12">
        <div class="img-profile">
            <img src="{icon_cartoon}" alt="" style="max-width: 100%;">
            <div class="row">
                <div class="col-4 text-center" style="justify-content: center;">
                    {#if loaDing}
                    <div>
                        <a href="{dataSetting.lineurl}" target="_blank"><span class="badge rounded-pill text-bg-success"><Fa icon={faLine} size="xxl" style="font-size: 1rem;"/> <span style="font-size: 1rem; font-weight:400;">{dataSetting.lineid}</span></span></a>
                    </div>
                    {:else}
                    <Fa icon={faCircleNotch} size="lg" class="text-dark" spin style="margin-top:20px;"/> 
                    {/if}
                </div>
                <div class="col-8 text-center">
                    <h6>Wellcome.</h6>
                    {#if loaDing}
                    <p>{member_name} <button type="button"  on:click={() => push('/setting')} style="background: transparent; border: 0px; padding: 0;"><Fa icon={faGear} size="md" spin  style="color:blue; cursor:pointer;" /></button></p>
                    <p><Fa icon={faUser} size="md" class="text-dark"  /> <span class="text-dark">{acc_name} <button type="button"  on:click={() => Logout()} style="background: transparent; border: 0px; padding: 0;"><Fa icon={faSignOut} size="md"  style="color:orange; cursor:pointer;" /></button></span></p>
                    <p><Fa icon={faBahtSign} size="md" style="color:c1a305;"  /> 
                        {#if loaDing2}
                        <span style="color: #c1a305; font-weight: 600;">{balance}</span> 
                        {:else}
                            <Fa icon={faCircleNotch} size="sm" class="text-dark" spin/> 
                        {/if}
                        <button type="button"   on:click={() => getBalance2()}  style="background: transparent; border: 0px; padding: 0;"><Fa icon={faArrowsRotate} size="md"    style="color:red; cursor:pointer;" /></button></p>
                    {:else}
                    <Fa icon={faCircleNotch} size="lg" class="text-dark" spin style="margin-top:20px;"/>  
                    {/if}
                </div>
            </div>
        </div>
    </div>
    <div class="col-12 mt-2">
        <div class="row">
            <div class="col-3">
                <div class="card shadow-sm rounded blog-mains"  on:click={() => push('/deposit')}>
                    <div class="anigirl">
                        <img src="./assets/images/ani-1.png" alt="" style="max-width: 100%;">
                    </div>
                    
                    <div class="card-body d-flex flex-nowrap p-2 justify-content-center" style="z-index:4;">
                        <div class=" text-center ms-1 me-1 " >
                            <div>
                                <img src="{icon_deposit}" class="img-fluid mb-0" style="height: 65px;"><br />
                            </div>
                        </div>
                        <div class="ribbons d">ฝากเงิน</div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="card shadow-sm rounded blog-mains" style="" on:click={() => push('/withdraw')}>
                    <div class="anigirl">
                        <img src="./assets/images/ani-1.png" alt="" style="max-width: 100%;">
                    </div>
                <!-- <div class="night">
					<div class="shooting_star"></div>
					<div class="shooting_star"></div>
					<div class="shooting_star"></div>
					<div class="shooting_star"></div>
					<div class="shooting_star"></div>
					<div class="shooting_star"></div>
					<div class="shooting_star"></div>
					<div class="shooting_star"></div>
					<div class="shooting_star"></div>
				</div> -->
                <div class="anigirl">
                    <img src="./assets/images/ani-1.png" alt="" style="max-width: 100%;">
                </div>
                    <div class="card-body d-flex flex-nowrap p-2 justify-content-center"  style="z-index:4;">
                        
                        <div class=" text-center ms-1 me-1 ">
                            <div>
                                <img src="{icon_withdraw}" class="img-fluid mb-0" style="height: 65px;"><br />
                            </div>
                        </div>
                        <div class="ribbons w">ถอนเงิน</div>
                    </div> 
                </div>
            </div>
            <div class="col-3">
                <div class="card shadow-sm rounded blog-mains" style="" on:click={() => push('/history')}>
                    <div class="anigirl">
                        <img src="./assets/images/ani-1.png" alt="" style="max-width: 100%;">
                    </div>
                    <div class="card-body d-flex flex-nowrap p-2 justify-content-center" style="z-index:4;">
                        <div class=" text-center ms-1 me-1 " >
                            <div>
                                <img src="{icon_history}" class="img-fluid mb-0" style="height: 65px;"><br />
                            </div>
                        </div>
                        <div class="ribbons h">ประวัติ</div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="card shadow-sm rounded blog-mains" style="" on:click={() => push('/affiliate')}>
                    <div class="anigirl">
                        <img src="./assets/images/ani-1.png" alt="" style="max-width: 100%;">
                    </div>
                    <div class="card-body d-flex flex-nowrap p-2 justify-content-center" style="z-index:4;">
                        <div class=" text-center ms-1 me-1 " >
                            <div>
                                <img src="{icon_aff}" class="img-fluid mb-0" style="height: 65px;"><br />
                            </div>
                        </div>
                        <div class="ribbons a">แนะนำเพื่อน</div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    {#if isPlarform}
    <div class="col-12 mt-3 mb-5">
        <div class="card rounded" style="background-color: transparent !important;border:0px !important;">
            <div class="card-body" style="padding: 0px;">
                <div class="col-12 tab-play">
                    <Fa icon={faFutbolBall} size="lg" class="text-white" spin style="color: gold !important;" /> <span style="font-weight: 600; letter-spacing: 2px;">ทางเข้าเล่น</span>
                </div>
                <div class="row p-1 gap-2 justify-content-center mt-2">
                    {#if x}
                        {#if platformList.length==1}
                        
                        {#if platformList[0].platform_prefix!='UFA'}
                        <!-- <div class="col-3" style="padding:3px !important;">
                            <button class="btn-games  -casino casino-btn  me-0 ms-0"   on:click={() => openGameOther('lastgame')} style="width: 100% !important;" >
                                <img decoding="async" src="./assets/platform/lastgame.png" alt="เกมล่าสุด" class="img-fluid">
                            </button>
                        </div>
                        <div class="col-3" style="padding:3px !important;">
                            <button class="btn-games  -casino casino-btn  me-0 ms-0" on:click={() => openGameOther('gamehit')}  style="width: 100% !important;" >
                                <img decoding="async" src="./assets/platform/gamehit.png" alt="เกมฮิต" class="img-fluid">
                            </button>
                        </div> -->
                        {/if}
                    {:else}
                    <!-- <div class="col-3" style="padding:3px !important;" >
                        <button class="btn-games  -casino casino-btn  me-0 ms-0"  on:click={() => openGameOther('lastgame')}  style="width: 100% !important;" >
                            <img decoding="async" src="./assets/platform/lastgame.png" alt="เกมล่าสุด" class="img-fluid">
                        </button>
                    </div>
                    <div class="col-3" style="padding:3px !important;">
                        <button class="btn-games  -casino casino-btn  me-0 ms-0"  on:click={() => openGameOther('gamehit')}  style="width: 100% !important;" >
                            <img decoding="async" src="./assets/platform/gamehit.png" alt="เกมฮิต" class="img-fluid">
                        </button>
                    </div> -->
                    {/if}
                    {#each platformList as prs}
                    <div class="col-3" style="padding:3px !important;">
                        {#if prs.active=='O'}
                        <button class="btn-games  -casino casino-btn  me-0 ms-0" on:click={() => openGame(prs.platform_prefix)} style="width: 89px !important;" >
                            {#if prs.platform_prefix=='GMZ'}
                            <img decoding="async" src="./assets/platform/{configs.gmz}.png" alt="{prs.platform_name}" class="img-fluid">
                            {:else}
                            <img decoding="async" src="./assets/platform/{prs.platform_prefix}.png" alt="{prs.platform_name}" class="img-fluid">
                            {/if}
                            <div class="-text-provider-wrapper">
                                <div class="-text-nav-menu -title-mobile">{prs.platform_name}</div>
                            </div>
                        </button>
                        {:else}
                        <button class="btn-games  -casino casino-btn  me-0 ms-0"  style="width: 89px !important;" >
                            <img decoding="async" src="./assets/platform/{prs.platform_prefix}.png" alt="{prs.platform_name}" class="img-fluid">
                            <div class="-text-provider-wrapper">
                                <div class="-text-nav-menu -title-mobile">{prs.platform_name}</div>
                            </div>
                            <div style="background-color: black;position:absolute;width:100%;height:100%;opacity:0.5;top:0px;border-redius:10px;" class="pt-4">ติด Promotion ไม่สามารถเล่นได้</div>
                        </button>
                        {/if}
                    </div>
                    
                    {/each}
                    {/if}
                </div>

                <div class="col-12 tab-play">
                    <Fa icon={faFutbolBall} size="lg" class="text-white"   /> <span>กิจกรรม</span>
                </div>
                <div class="row p-1  mt-2">
                    <div class="col-12 text-center text-white" style="cursor: pointer;" on:click={() => push('/cashback')} >
                        <img decoding="async" src="./assets/icon/cashback_new.gif"  class="img-fluid border border-warning rounded border-2">
                        <h6 class="mt-1">คืนยอดเสีย</h6>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    {/if}
    {#if isGame}
    <div class="col-12 mt-3 mb-5">
        <div class="card rounded" style="background-color: transparent !important;border:0px !important;">
            <div class="card-body" style="padding: 0px;">
                <div class="col-12 tab-play">
                    {#if platformList.length==1}
                    <Fa icon={faFutbolBall} size="lg" class="text-white" spin style="color: gold !important;" /> <span style="color: gold !important; font-weight: 600; letter-spacing: 2px;">ทางเข้าเล่น</span>
                    {:else}
                    <a href="{'javascript:;'}" style="text-decoration:none;" on:click={() => closeGame()}><Fa icon={faChevronCircleLeft} size="lg" class="text-white" /> <span class="text-white">กลับเลือกค่าย</span></a>
                    {/if}
                    
                </div>
                <div class="row p-1 gap-2 justify-content-center mt-2">
                    {#if platformList.length==1}
                        {#if platformList[0].platform_prefix!='UFA'}
                            <!-- <button class="btn-games  -casino casino-btn  me-0 ms-0"   on:click={() => openGameOther('lastgame')} style="width: 89px !important;"  >
                                <img decoding="async" src="./assets/platform/lastgame.png" alt="เกมล่าสุด" class="img-fluid">
                            </button>
                            <button class="btn-games  -casino casino-btn  me-0 ms-0"   on:click={() => openGameOther('gamehit')} style="width: 89px !important;" >
                                <img decoding="async" src="./assets/platform/gamehit.png" alt="เกมฮิต" class="img-fluid">
                            </button> -->
                        {/if}
                    {/if}
                    {#each gametypeList as item}
                        <button class="btn-games  -casino casino-btn  me-0 ms-0" on:click={() => push('/provider/'+platformPrefix+'/'+item)} style="width: 89px !important;" >
                            <img decoding="async" src="./assets/category/v2/{item}.png" alt="{item}" class="img-fluid">
                            <div class="-text-provider-wrapper">
                                <div class="-text-nav-menu -title-mobile">{item}</div>
                            </div>
                        </button>
                    {/each}
                </div>
            </div>
        </div>
    </div>
    {/if}
    {#if isGameOther}
    <div class="col-12 mt-2 mb-5 mt-f11">
        <div class="rounded blog-play" style="background-color: transparent !important;border:0px !important;">
            <div class="card-body" style="padding: 0px;">
                <div class="col-12 tab-play">
                    {#if platformList.length==1}
                    <a href="{'javascript:;'}" style="text-decoration:none;" on:click={() => closeGameOther()}><Fa icon={faChevronCircleLeft} size="lg" class="text-white" /> <span class="text-white"> ย้อนกลับ</span></a>
                    {:else}
                    <a href="{'javascript:;'}" style="text-decoration:none;" on:click={() => closeGame()}><Fa icon={faChevronCircleLeft} size="lg" class="text-white" /> <span class="text-white"> กลับเลือกค่าย</span></a>
                    {/if}
                </div>
                <div class="row p-1 justify-content-center mt-2">
                    {#each gameListHit as prs}
                    <div class="col-3 text-center mb-1 pointer" style="padding: 0px 5px 5px 5px;" >
                        <a href="#/startgame/{prs._id}" target="_blank" style="text-decoration: none !important;">
                        <img src="{prs.image}" class="img-fluid" style="border-radius: 10px;">
                        
                        <span class="text-white text-sm" style="text-decoration: none !important;font-size:0.5rem;">{prs.gameName}</span>
                        </a>
                    </div>
                    {/each}
                </div>
            </div>
        </div>
    </div>
    {/if}
</div>
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3">
        <HeaderThemes/>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
    <div class="col-12">
        <div class="blog-profile">
            <img src="{srcImg}" class="avartar" alt="Avartar"/>
            <div class="blog-profile-child">
                <p>ยินดีต้อนรับ</p>
                {#if loaDing}
                <p>{member_name}</p>
                <h5 class="balances"><Fa icon={faBahtSign} size="md"/>  
                    {#if loaDing2}
                    <span>{balance}</span> 
                    {:else}
                        <Fa icon={faCircleNotch} size="sm" class="text-white" spin/> 
                    {/if}
                </h5>
                <h6 class="createDtm">สมัคร {new Date(parseInt(createdtm) * 1000).toLocaleString('th-TH')}</h6>
                {:else}
                <Fa icon={faCircleNotch} size="lg" class="text-white" spin style="margin-top:20px;"/>  
                {/if}
                <button type="button"  class="btn-refreshs"  on:click={() => getBalance2()}  style="background: transparent; border: 0px; padding: 0;"><Fa icon={faArrowsRotate} size="md"    style="color:red; cursor:pointer;" /></button>
            </div>
            <div class="profile-footer">
                <div class="col-6 username-s">
                    <p><Fa icon={faUserCircle} size="sm" class="text-white"/> {acc_name}</p>
                </div>
                <div class="col-6  username-f">
                    <p>
                        <a href="javascript:;"  on:click={() => push('/setting')} > 
                            ข้อมูลสมาชิก 
                            <Fa icon={faGear} size="md" spin />
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="btns-home">
        <div class="row">
            <div class="col"  on:click={() => push('/deposit')}>
                <div>
                    <img src="{icon_deposit}" class="img-fluid mb-0" alt="ฝากเงิน">
                </div>
                <span>ฝากเงิน</span>
            </div>
            <div class="col"  on:click={() => push('/withdraw')}>
                <div>
                    <img src="{icon_withdraw}" class="img-fluid mb-0" alt="ถอนเงิน">
                </div>
                <span>ถอนเงิน</span>
            </div>
            <div class="col"  on:click={() => push('/history')}>
                <div>
                    <img src="{icon_history}" class="img-fluid mb-0" alt="ประวัติ">
                </div>
                <span>ประวัติ</span>
            </div>
            <div class="col"  on:click={() => push('/affiliate')}>
                <div>
                    <img src="{icon_aff}" class="img-fluid mb-0" alt="แนะนำเพื่อน">
                </div>
                <span>แนะนำเพื่อน</span>
            </div>
        </div>
    </div>
    {#if isPlarform}
    <div class="col-12 mt-2 mb-5 mt-f11">
        <div class="rounded blog-play" style="background-color: transparent !important;border:0px !important;">
            <div class="card-body" style="padding: 0px;">
                <div class="col-12 tab-play">
                    <Fa icon={faFutbolBall} size="lg" class="text-white" spin  /> <span style=" font-weight: 600; letter-spacing: 2px;">เข้าเล่น</span>
                </div>
                <div class="row p-1 justify-content-center mt-2" style="margin: 0px !important;">
                    {#if x}
                    {#if platformList.length==1}
                    
                        {#if platformList[0].platform_prefix!='UFA'}
                        <!-- <div class="col-3" style="padding:3px !important;">
                            <button class="btn-games  -casino casino-btn  me-0 ms-0"   on:click={() => openGameOther('lastgame')} style="width: 100% !important;" >
                                <img decoding="async" src="./assets/platform/lastgame.png" alt="เกมล่าสุด" class="img-fluid">
                            </button>
                        </div>
                        <div class="col-3" style="padding:3px !important;">
                            <button class="btn-games  -casino casino-btn  me-0 ms-0" on:click={() => openGameOther('gamehit')}  style="width: 100% !important;" >
                                <img decoding="async" src="./assets/platform/gamehit.png" alt="เกมฮิต" class="img-fluid">
                            </button>
                        </div> -->
                        {/if}
                    {:else}
                    <!-- <div class="col-3" style="padding:3px !important;" >
                        <button class="btn-games  -casino casino-btn  me-0 ms-0"  on:click={() => openGameOther('lastgame')}  style="width: 100% !important;" >
                            <img decoding="async" src="./assets/platform/lastgame.png" alt="เกมล่าสุด" class="img-fluid">
                        </button>
                    </div>
                    <div class="col-3" style="padding:3px !important;">
                        <button class="btn-games  -casino casino-btn  me-0 ms-0"  on:click={() => openGameOther('gamehit')}  style="width: 100% !important;" >
                            <img decoding="async" src="./assets/platform/gamehit.png" alt="เกมฮิต" class="img-fluid">
                        </button>
                    </div> -->
                    {/if}
                    {#each platformList as prs}
                    <div class="col-3" style="padding:3px !important;">
                        {#if prs.active=='O'}
                        <button class="btn-games  -casino casino-btn  me-0 ms-0" on:click={() => openGame(prs.platform_prefix)}  style="width: 100% !important;" >
                            {#if prs.platform_prefix=='GMZ'}
                            <img decoding="async" src="./assets/platform/{configs.gmz}.png" alt="{prs.platform_name}" class="img-fluid">
                            {:else}
                            <img decoding="async" src="./assets/platform/{prs.platform_prefix}.png" alt="{prs.platform_name}" class="img-fluid">
                            {/if}
                            <div class="-text-provider-wrapper">
                                <div class="-text-nav-menu -title-mobile">{prs.platform_name}</div>
                            </div>
                        </button>
                        {:else}
                        <button class="btn-games  -casino casino-btn  me-0 ms-0"  >
                            <img decoding="async" src="./assets/platform/{prs.platform_prefix}.png" alt="{prs.platform_name}" class="img-fluid">
                            <div class="-text-provider-wrapper">
                                <div class="-text-nav-menu -title-mobile">{prs.platform_name}</div>
                            </div>
                            <div style="background-color: black;position:absolute;width:100%;height:100%;opacity:0.5;top:0px;border-redius:10px;" class="pt-4">ติด Promotion ไม่สามารถเล่นได้</div>
                        </button>
                        {/if}
                    </div>
                    
                    {/each}
                    {/if}
                </div>
                <div class="col-12 tab-play">
                    <Fa icon={faFutbolBall} size="lg" class="text-white"/> <span style="font-weight: 600; letter-spacing: 2px;">กิจกรรม</span>
                </div>
                <div class="row p-1 justify-content-center mt-2">
                    <div class="col-12 text-center text-white" style="cursor: pointer;" on:click={() => push('/cashback')} >
                        <img decoding="async" src="./assets/icon/cashback_new.gif"  class="img-fluid border border-warning rounded border-2">
                        <h6 class="mt-1">คืนยอดเสีย</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/if}
    {#if isGame}
    <div class="col-12 mt-2 mb-5 mt-f11">
        <div class="rounded blog-play" style="background-color: transparent !important;border:0px !important;">
            <div class="card-body" style="padding: 0px;">
                <div class="col-12 tab-play">
                    {#if platformList.length==1}
                    <Fa icon={faFutbolBall} size="lg" class="text-white"/> <span style="font-weight: 600; letter-spacing: 2px;">เข้าเล่น</span>
                    {:else}
                    <a href="{'javascript:;'}" style="text-decoration:none;" on:click={() => closeGame()}><Fa icon={faChevronCircleLeft} size="lg" class="text-white" /> <span class="text-white">กลับเลือกค่าย</span></a>
                    {/if}
                </div>
                <div class="row p-1 justify-content-center mt-2">
                    {#if platformList.length==1}
                        {#if platformList[0].platform_prefix!='UFA'}
                            <!-- <button class="btn-games  -casino casino-btn  me-0 ms-0"   on:click={() => openGameOther('lastgame')} >
                                <img decoding="async" src="./assets/platform/lastgame.png" alt="เกมล่าสุด" class="img-fluid">
                            </button>
                            <button class="btn-games  -casino casino-btn  me-0 ms-0"   on:click={() => openGameOther('gamehit')} >
                                <img decoding="async" src="./assets/platform/gamehit.png" alt="เกมฮิต" class="img-fluid">
                            </button> -->
                        {/if}
                    {/if}
                    {#each gametypeList as item}
                        <button class="btn-games  -casino casino-btn  me-0 ms-0" on:click={() => push('/provider/'+platformPrefix+'/'+item)} >
                            <img decoding="async" src="./assets/category/v2/{item}.png" alt="{item}" class="img-fluid">
                            <div class="-text-provider-wrapper">
                                <div class="-text-nav-menu -title-mobile">{item}</div>
                            </div>
                        </button> 
                    {/each}
                </div>
            </div>
        </div>
    </div>
    {/if}
    {#if isGameOther}
    <div class="col-12 mt-2 mb-5 mt-f11">
        <div class="rounded blog-play" style="background-color: transparent !important;border:0px !important;">
            <div class="card-body" style="padding: 0px;">
                <div class="col-12 tab-play">
                    {#if platformList.length==1}
                    <a href="{'javascript:;'}" style="text-decoration:none;" on:click={() => closeGameOther()}><Fa icon={faChevronCircleLeft} size="lg" class="text-white" /> <span class="text-white"> ย้อนกลับ</span></a>
                    {:else}
                    <a href="{'javascript:;'}" style="text-decoration:none;" on:click={() => closeGame()}><Fa icon={faChevronCircleLeft} size="lg" class="text-white" /> <span class="text-white"> กลับเลือกค่าย</span></a>
                    {/if}
                </div>
                <div class="row p-1 justify-content-center mt-2">
                    {#each gameListHit as prs}
                    <div class="col-3 text-center mb-1 pointer" style="padding: 0px 5px 5px 5px;" >
                        <a href="#/startgame/{prs._id}" target="_blank" style="text-decoration: none !important;">
                        <img src="{prs.image}" class="img-fluid" style="border-radius: 10px;">
                        
                        <span class="text-white text-sm" style="text-decoration: none !important;font-size:0.5rem;">{prs.gameName}</span>
                        </a>
                    </div>
                    {/each}
                </div>
            </div>
        </div>
    </div>
    {/if}
</div>
<div class="themes-home-dark " style="display: none;margin-left:0px;margin-right:0px;">
    <div class="row" style="margin: 0;">
        {#if  objs}
        <div class="col-12 blog-slids"  style="padding: 0;">
                <Carousel
                autoplayDuration={0}
                duration={5000}
                autoplay
                timingFunction="fadein"
                dots={false}
                arrows={false}
                >
                    {#each objs as data}
                    <div class="col-12" style="padding: 0 !important;">
                        <img src="{data}" style="max-width: 100% !important;" />
                    </div>
                    {/each}
                </Carousel>
        </div>
        {/if}
    </div>
    <div class="blog-dark-section mb-4">
        <div class="row" style="margin-left:0px;margin-right:0px;">
            <div class="col-6">
                <div class="blog-user">
                    <div class="blog-a">
                        <img src="./assets/images/img-wallet.png" class="img-fluid imgs" />
                    </div>
                    <div class="blog-b">
                        {#if loaDing}
                            <div class="md-1" on:click={() => push('/setting')}><Fa icon={faGear} size="sm" class="text-white" style="color:gold !important;" spin/>  {acc_name}</div>
                        {:else}
                            <Fa icon={faCircleNotch} size="sm" class="text-white" spin/> 
                        {/if}
                        <div class="md-2">ยอดเงินคงเหลือ</div>
                        {#if loaDing}
                        <h5 class="balances md-3">  
                            {#if loaDing2}
                            <span>{balance.toLocaleString('th-TH')}</span> 
                            {:else}
                                <Fa icon={faCircleNotch} size="sm" class="text-white" spin/> 
                            {/if}
                            <Fa icon={faBahtSign} size="md"/>
                            <button type="button"  class="btn-refreshs"  on:click={() => getBalance2()}  style="background: transparent; border: 0px; padding: 0;"><Fa icon={faArrowRotateRight} size="md"    style="color:gold; cursor:pointer;" /></button>
                        </h5>
                        {:else}
                            <Fa icon={faCircleNotch} size="sm" class="text-white" spin/> 
                        {/if}
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="row blog-r">
                    <div class="col-4">
                        <div class="btn-otes"  on:click={() => push('/cashback')}><img src="./assets/images/ico-new.png" class="ic-new"/> <Fa icon={faHandHoldingDollar} size="md"/> ยอดเสีย</div>
                    </div>
                    <div class="col-4">
                        <div class="btn-otes"  on:click={() => push('/ranking')}> <Fa icon={faRankingStar} size="md"/> Ranking</div>
                    </div>
                    <div class="col-4" style="padding-right: 5px;">
                        <div class="btn-otes"  on:click={() => checkPromotion()}> <Fa icon={faGift} size="md"/> เติมโค้ด</div>
                    </div>
                    <div class="col-12">
                        <div class="blog-affss" >
                            <div class="ms-1">
                                <img src="../assets/icon/setting_v2.png" class="ic-affs"/>
                            </div>
                            <div class="ms-2">
                                <h5>รายได้จากแนะนำเพื่อน</h5>
                                <div> {affbalance.toLocaleString('th-TH')} <Fa icon={faBahtSign} size="md"/></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btns-home">
            <div class="row"  style="margin-left:0px;margin-right:0px;">
                <div class="col blinks"  on:click={() => push('/deposit')}>
                    <div>
                        <img src="{icon_deposit}" class="img-fluid mb-0" alt="ฝากเงิน">
                    </div>
                    <span>ฝากเงิน</span>
                </div>
                <div class="col"  on:click={() => push('/withdraw')}>
                    <div>
                        <img src="{icon_withdraw}" class="img-fluid mb-0" alt="ถอนเงิน">
                    </div>
                    <span>ถอนเงิน</span>
                </div>
                <div class="col"  on:click={() => push('/history')}>
                    <div>
                        <img src="{icon_history}" class="img-fluid mb-0" alt="ประวัติ">
                    </div>
                    <span>ประวัติ</span>
                </div>
                <div class="col"  on:click={() => push('/affiliate')}>
                    <div>
                        <img src="{icon_aff}" class="img-fluid mb-0" alt="แนะนำเพื่อน">
                    </div>
                    <span>แนะนำเพื่อน</span>
                </div>
            </div>
        </div>

        {#if isPlarform}
        <div class="col-12" id="playgamesss">
            <div class="rounded blog-play" style="background-color: transparent !important;border:0px !important;">
                <div class="card-body" style="padding: 0px;">
                    <div class="head-title">
                        <Fa icon={faFutbolBall} size="lg" class="text-white" spin  /> <span style=" font-weight: 600; letter-spacing: 2px;">ทางเข้าเล่น</span>
                    </div>
                    <div class="row p-1 justify-content-center mt-2" style="margin: 0px !important;">
                        {#if x}
                        {#if platformList.length==1}
                        
                            {#if platformList[0].platform_prefix!='UFA'}
                            <!-- <div class="col-3" style="padding:3px !important;">
                                <button class="btn-games  -casino casino-btn  me-0 ms-0" on:click={() => openGameOther('gamehit')}  style="width: 100% !important;" >
                                    <img decoding="async" src="./assets/platform/gamehit.png" alt="เกมฮิต" class="img-fluid">
                                </button>
                            </div> -->
                            {/if}
                        {:else}
                        <!-- <div class="col-3" style="padding:3px !important;">
                            <button class="btn-games  -casino casino-btn  me-0 ms-0"  on:click={() => openGameOther('gamehit')}  style="width: 100% !important;" >
                                <img decoding="async" src="./assets/platform/gamehit.png" alt="เกมฮิต" class="img-fluid">
                            </button>
                        </div> -->
                        {/if}
                        {#each platformList as prs}
                        <div class="col-3" style="padding:3px !important;">
                            {#if prs.active=='O'}
                            <button class="btn-games  -casino casino-btn  me-0 ms-0" on:click={() => openGame(prs.platform_prefix)}  style="width: 100% !important;" >
                                {#if prs.platform_prefix=='GMZ'}
                                <img decoding="async" src="./assets/platform/{configs.gmz}.png" alt="{prs.platform_name}" class="img-fluid">
                                {:else}
                                <img decoding="async" src="./assets/platform/{prs.platform_prefix}.png" alt="{prs.platform_name}" class="img-fluid">
                                {/if}
                                <div class="-text-provider-wrapper">
                                    <div class="-text-nav-menu -title-mobile">{prs.platform_name}</div>
                                </div>
                            </button>
                            {:else}
                            <button class="btn-games  -casino casino-btn  me-0 ms-0"  >
                                <img decoding="async" src="./assets/platform/{prs.platform_prefix}.png" alt="{prs.platform_name}" class="img-fluid">
                                <div class="-text-provider-wrapper">
                                    <div class="-text-nav-menu -title-mobile">{prs.platform_name}</div>
                                </div>
                                <div style="background-color: black;position:absolute;width:100%;height:100%;opacity:0.5;top:0px;border-redius:10px;" class="pt-4">ติด Promotion ไม่สามารถเล่นได้</div>
                            </button>
                            {/if}
                        </div>
                        
                        {/each}
                        {/if}
                    </div>
                </div>
            </div>
        </div>
        {/if}
        {#if isGame}
        <div class="col-12 mt-1">
            <div class="rounded blog-play" style="background-color: transparent !important;border:0px !important;">
                <div class="card-body" style="padding: 0px;">
                    <div class="head-title">
                        {#if platformList.length==1}
                        <Fa icon={faFutbolBall} size="lg" class="text-white"/> <span style="font-weight: 600; letter-spacing: 2px;">ทางเข้าเล่น</span>
                        {:else}
                        <a href="{'javascript:;'}" style="text-decoration:none;" on:click={() => closeGame()}><Fa icon={faChevronCircleLeft} size="lg" class="text-white" /> <span class="text-white">กลับเลือกค่าย</span></a>
                        {/if}
                    </div>
                    <div class="row p-1 justify-content-center mt-2">
                        {#if platformList.length==1}
                            {#if platformList[0].platform_prefix!='UFA'}
                                <!-- <button class="btn-games  -casino casino-btn  me-0 ms-0"   on:click={() => openGameOther('gamehit')} >
                                    <img decoding="async" src="./assets/platform/gamehit.png" alt="เกมฮิต" class="img-fluid">
                                </button> -->
                            {/if}
                        {/if}
                        {#each gametypeList as item}
                            <button class="btn-games  -casino casino-btn  me-0 ms-0" on:click={() => push('/provider/'+platformPrefix+'/'+item)} >
                                <img decoding="async" src="./assets/category/v2/{item}.png" alt="{item}" class="img-fluid">
                                <div class="-text-provider-wrapper">
                                    <div class="-text-nav-menu -title-mobile">{item}</div>
                                </div>
                            </button> 
                        {/each}
                    </div>
                </div>
            </div>
        </div>
        {/if}
        {#if isGameOther}
        <div class="col-12 mt-2 mb-5 mt-f11">
            <div class="rounded blog-play" style="background-color: transparent !important;border:0px !important;">
                <div class="card-body" style="padding: 0px;">
                    <div class="head-title">
                        {#if platformList.length==1}
                        <a href="{'javascript:;'}" style="text-decoration:none;" on:click={() => closeGameOther()}><Fa icon={faChevronCircleLeft} size="lg" class="text-white" /> <span class="text-white"> ย้อนกลับ</span></a>
                        {:else}
                        <a href="{'javascript:;'}" style="text-decoration:none;" on:click={() => closeGame()}><Fa icon={faChevronCircleLeft} size="lg" class="text-white" /> <span class="text-white"> กลับเลือกค่าย</span></a>
                        {/if}
                    </div>
                    <div class="row p-1 justify-content-center mt-2"  style="padding: 0px 15px 0 15px !important;">
                        {#each gameListHit as prs}
                        <div class="col-3 text-center mb-1 pointer" style="padding: 0px 5px 5px 5px;" >
                            <a href="#/startgame/{prs._id}" target="_blank" style="text-decoration: none !important;">
                            <img src="{prs.image}" class="img-fluid" style="border-radius: 10px;">
                            
                            <span class="text-white text-sm" style="text-decoration: none !important;font-size:0.5rem;">{prs.gameName}</span>
                            </a>
                        </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
        {/if}
        {#if isGameOtherDark}
        <div class="col-12 mb-1">
            <div class="rounded blog-play" style="background-color: transparent !important;border:0px !important;">
                <div class="card-body">
                    <div class="head-title">
                        <Fa icon={faFutbolBall} size="lg" class="text-white"/> <span style="font-weight: 600; letter-spacing: 2px;"> พึ่งเล่นล่าสุด</span>
                    </div>
                    <div class="row p-1 justify-content-center mt-2" style="padding: 0px 15px 0 15px !important;">
                        {#each gameListHitDark as prs}
                        <div class="col-3 text-center mb-1 pointer" style="padding: 0px 5px 5px 5px;" >
                            <a href="#/startgame/{prs._id}" target="_blank" style="text-decoration: none !important;">
                            <img src="{prs.image}" class="img-fluid" style="border-radius: 10px;">
                            
                            <span class="text-white text-sm" style="text-decoration: none !important;font-size:0.5rem;">{prs.gameName}</span>
                            </a>
                        </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
        {/if}
    </div>
</div>
<div class="footer-default">
    <Footer />
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>

<style>
    
    .circle {
        background-color:black;
        border:3px solid rgb(230, 196, 119);    
        height:200px;
        border-radius:50%;
        -moz-border-radius:50%;
        -webkit-border-radius:50%;
        width:200px;
    }
    .btn-games {
        margin: 0;
        padding:0;
        background-color: transparent;
        /* padding: 7px 10px; */
        /* background: linear-gradient(155deg, #424242, #101010); */
        position: relative;
        /* box-shadow: 0 5px 10px #000000b0; */
        border-radius: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: all .3s;
        font-size: 10px;
        position: relative;
        color: #FFF;
        width: 100px;
        border: 0px;
    }
    .-text-provider-wrapper{
        margin-top: 5px;
        display: none;
    }
    .pointer{
        cursor: pointer;
    }
    .ribbons {
        border-radius: 0 30px 30px 0;
        padding: 0px 5px;
        box-shadow: 2px 5px 10px #21252926;
        color: #fff;
        font-size: .6rem;
        font-weight: 500;
        position: absolute;
        left: -1px;
        bottom: 0px;
        z-index: 3;
    }
    .ribbons.d{
        background: #45CB85;
    }
    .ribbons.w{
        background: #dc3545;
    }
    .ribbons.a{
        background: #4b38b3;
    }
    .ribbons.h{
        background: #ffbe0b;
    }
    .blog-mains {
        cursor: pointer;
        position: relative;
        background: linear-gradient(135deg, rgb(0 0 0) 0%, rgb(86 80 80) 50%, rgb(131 120 120) 51%, rgb(54 50 50) 71%, rgb(0 0 0) 100%);
                box-shadow: 5px 5px 10px #000 !important;animation: AnimationName 5s ease infinite; border: medium none;
    }
    .blog-mains:hover{
        opacity: 0.8;
    }
    .night {
        top: 0;
        opacity: 1.2;
        position: absolute;
        width: 10%;
        left: -40px;
        height: 100%;
        transform: rotateZ(45deg);
    }
    .shooting_star {
        position: absolute;
        left: 50%;
        top: 50%;
        height: 2px;
        background: linear-gradient(-45deg, #e0ddd5, rgba(0, 0, 255, 0));
        border-radius: 999px;
        filter: drop-shadow(0 0 6px #699bff);
        -webkit-animation: tail 3000ms ease-in-out infinite, shooting 3000ms ease-in-out infinite;
        animation: tail 3000ms ease-in-out infinite, shooting 3000ms ease-in-out infinite;
    }
    .shooting_star::before {
        content: "";
        position: absolute;
        top: calc(50% - 1px);
        right: 0;
        height: 2px;
        background: linear-gradient(-45deg, rgba(0, 0, 255, 0), #ebeae7, rgba(0, 0, 255, 0));
        transform: translateX(50%) rotateZ(45deg);
        border-radius: 100%;
        -webkit-animation: shining 3000ms ease-in-out infinite;
        animation: shining 3000ms ease-in-out infinite;
    }
    .shooting_star::after {
        content: "";
        position: absolute;
        top: calc(50% - 1px);
        right: 0;
        height: 2px;
        background: linear-gradient(-45deg, rgba(0, 0, 255, 0), #e4e3e2, rgba(0, 0, 255, 0));
        transform: translateX(50%) rotateZ(45deg);
        border-radius: 100%;
        -webkit-animation: shining 3000ms ease-in-out infinite;
        animation: shining 3000ms ease-in-out infinite;
        transform: translateX(50%) rotateZ(-45deg);
    }
    .shooting_star:nth-child(1) {
        top: calc(50% - -35px);
        left: calc(50% - 171px);
        -webkit-animation-delay: 8883ms;
        animation-delay: 8883ms;
    }
    .shooting_star:nth-child(1)::before, .shooting_star:nth-child(1)::after {
        -webkit-animation-delay: 8883ms;
        animation-delay: 8883ms;
    }
    .shooting_star:nth-child(2) {
        top: calc(50% - -175px);
        left: calc(50% - 46px);
        -webkit-animation-delay: 4147ms;
        animation-delay: 4147ms;
    }
    .shooting_star:nth-child(2)::before, .shooting_star:nth-child(2)::after {
        -webkit-animation-delay: 4147ms;
        animation-delay: 4147ms;
    }
    .shooting_star:nth-child(3) {
        top: calc(50% - 143px);
        left: calc(50% - 19px);
        -webkit-animation-delay: 1625ms;
        animation-delay: 1625ms;
    }
    .shooting_star:nth-child(3)::before, .shooting_star:nth-child(3)::after {
        -webkit-animation-delay: 1625ms;
        animation-delay: 1625ms;
    }
    .shooting_star:nth-child(4) {
        top: calc(50% - 199px);
        left: calc(50% - 110px);
        -webkit-animation-delay: 5973ms;
        animation-delay: 5973ms;
    }
    .shooting_star:nth-child(4)::before, .shooting_star:nth-child(4)::after {
        -webkit-animation-delay: 5973ms;
        animation-delay: 5973ms;
    }
    .shooting_star:nth-child(5) {
        top: calc(50% - 183px);
        left: calc(50% - 128px);
        -webkit-animation-delay: 5975ms;
        animation-delay: 5975ms;
    }
    .shooting_star:nth-child(5)::before, .shooting_star:nth-child(5)::after {
        -webkit-animation-delay: 5975ms;
        animation-delay: 5975ms;
    }
    .shooting_star:nth-child(6) {
        top: calc(50% - 200px);
        left: calc(50% - 259px);
        -webkit-animation-delay: 9747ms;
        animation-delay: 9747ms;
    }
    .shooting_star:nth-child(6)::before, .shooting_star:nth-child(6)::after {
        -webkit-animation-delay: 9747ms;
        animation-delay: 9747ms;
    }
    .shooting_star:nth-child(7) {
        top: calc(50% - 142px);
        left: calc(50% - 256px);
        -webkit-animation-delay: 9399ms;
        animation-delay: 9399ms;
    }
    .shooting_star:nth-child(7)::before, .shooting_star:nth-child(7)::after {
        -webkit-animation-delay: 9399ms;
        animation-delay: 9399ms;
    }
    .shooting_star:nth-child(8) {
        top: calc(50% - 71px);
        left: calc(50% - 297px);
        -webkit-animation-delay: 4996ms;
        animation-delay: 4996ms;
    }
    .shooting_star:nth-child(8)::before, .shooting_star:nth-child(8)::after {
        -webkit-animation-delay: 4996ms;
        animation-delay: 4996ms;
    }
    .shooting_star:nth-child(9) {
        top: calc(50% - 113px);
        left: calc(50% - 295px);
        -webkit-animation-delay: 6090ms;
        animation-delay: 6090ms;
    }
    .shooting_star:nth-child(9)::before, .shooting_star:nth-child(9)::after {
        -webkit-animation-delay: 6090ms;
        animation-delay: 6090ms;
    }
    .shooting_star:nth-child(10) {
        top: calc(50% - -174px);
        left: calc(50% - 181px);
        -webkit-animation-delay: 8193ms;
        animation-delay: 8193ms;
    }
    .shooting_star:nth-child(10)::before, .shooting_star:nth-child(10)::after {
        -webkit-animation-delay: 8193ms;
        animation-delay: 8193ms;
    }
    .anigirl{
        position: absolute;
    width: 100%;
    height: auto;
    margin-top: 8px;
    left: 10px;
    right: 0;
    opacity: .8;
        z-index: 2;
    }
    .anigirl:nth-child(1){
    animation: anigirl 8s ease 0s infinite normal none;
    }
    .anigirl:nth-child(2){
    animation: lightning 2.5s ease 0s infinite normal none;
    width: 80%;
    top: 10px;
    }
    @keyframes anigirl {
    0.0%{
    }
    100%{
    }
    49.6%{
        transform: translate(0px,0px) scale(1.2);
    }
    }
    @keyframes lightning {

        0% {
            opacity: 0;
        }
        3% {
            opacity: 0;
        }
        6% {
            opacity: 1;
        }
        9% {
            opacity: 0;
        }
        12% {
            opacity: 1;
        }
        15% {
            opacity: 0;
        }
        18% {
            opacity: 1;
        }
    100%{
        opacity: 1;
    }

    }
    .anigirl img{
    width: 80%;
    }
    @-webkit-keyframes tail {
        0% {
            width: 0;
        }
        30% {
            width: 100px;
        }
        100% {
            width: 0;
        }
        }

        @keyframes tail {
        0% {
            width: 0;
        }
        30% {
            width: 100px;
        }
        100% {
            width: 0;
        }
        }
        @-webkit-keyframes shining {
        0% {
            width: 0;
        }
        50% {
            width: 30px;
        }
        100% {
            width: 0;
        }
        }
        @keyframes shining {
        0% {
            width: 0;
        }
        50% {
            width: 30px;
        }
        100% {
            width: 0;
        }
        }
        @-webkit-keyframes shooting {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(300px);
        }
        }
        @keyframes shooting {
        0% {
            transform: translateX(0);
        }
        100% {
            transform: translateX(300px);
        }
        }
        @-webkit-keyframes sky {
        0% {
            transform: rotate(45deg);
        }
        100% {
            transform: rotate(405deg);
        }
        }
        @keyframes sky {
        0% {
            transform: rotate(45deg);
        }
        100% {
            transform: rotate(405deg);
        }
    }
    .img-profile{
        position: relative;
    }
    .img-profile>.row{
        position: absolute;
        width: 100%;
        top: 59%;
    }
    .img-profile .col-8>h6{
        margin-bottom: 0px;
        
    }
    .img-profile .col-8>p{
        font-size: 12px;
        margin-bottom: 0px;
    }
    .img-profile .col-4{
        align-items: end;
        display: flex;
    }
    .tab-play{
        background: linear-gradient(135deg, rgb(0 0 0) 0%, rgb(86 80 80) 50%, rgb(131 120 120) 51%, rgb(54 50 50) 71%, rgb(0 0 0) 100%);
        box-shadow: 5px 5px 10px #000 !important;
        line-height: 30px;
        border-radius: 5px;
        padding: 2px 7px;
    }
</style>